// extracted by mini-css-extract-plugin
export default {"tooltip":"qz-z","arrow":"rz-z"};